import isString from 'lodash/isString'

const defaultPath = { name: 'orders' }

export default 
{
    methods: 
    {
        home()
        {
			let path = this.$route?.query?.to || defaultPath

			if ( isString(path) && path?.includes?.('/auth') )
			{
				path = defaultPath
			}

            this.sendNotification('Welcome!')

            this.$router.push(path, null, () => this.$router.push(defaultPath))
        },

        employeeLogin()
        {
            document.location.reload(true)

            this.sendNotification('Welcome Cogent Employee!')
        },

        internalLogin()
        {
            this.sendNotification('Successfully Logged in as ' + this.fullName)

            this.$router.push(defaultPath)
        }
    }
}